import { VIDEODATA } from "../../actions/portal";

export default function(state = [], action) {
  switch (action.type) {
    case VIDEODATA:
      return action.payload;
  }
  return state;
}
